const MAX_DECIMALS = 2;

function roundToMaxDecimals(value: number): number {
  if (Number.isInteger(value)) return value;
  const factor = 10 ** MAX_DECIMALS;
  return Math.round(value * factor) / factor;
}

export function formatMsToReadable(ms: number): string {
  const rounded = roundToMaxDecimals(ms);
  if (rounded < 1000) return `${rounded}ms`;
  const seconds = Math.floor(rounded / 1000);
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  if (minutes < 60) return secs > 0 ? `${minutes}min ${secs}s` : `${minutes}min`;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (mins > 0) return `${hours}h ${mins}min`;
  return `${hours}h`;
}
